import {DateRange, DateRangeFilterEnum} from '@/types'
import dayjs from 'dayjs'
import {z} from 'zod'
import {AssistiveRegimeEnum} from '../projects/types'

export const DashboardSearchParams = DateRange.merge(
    z.object({
        startDate: z.string().optional().default(dayjs().subtract(3, 'months').format('YYYY-MM-DD')),
        endDate: z.string().optional().default(dayjs().format('YYYY-MM-DD')),
        assistiveRegime: AssistiveRegimeEnum.optional(),
        sector: z.enum(['outpatient', 'domiciliary']).optional()
    })
)
export type DashboardSearchParams = z.infer<typeof DashboardSearchParams>

export const DashboardConsultantSearchParams = z.object({
    startDate: z.string().optional().default(dayjs().startOf('year').format('YYYY-MM-DD')),
    endDate: z.string().optional().default(dayjs().endOf('year').format('YYYY-MM-DD')),
    consultant: z.string().optional()
})
export type DashboardConsultantSearchParams = z.infer<typeof DashboardConsultantSearchParams>

export const DashboardEconomicSearchParams = DateRange.merge(
    z.object({
        startDate: z.string().optional().default(dayjs().startOf('year').format('YYYY-MM-DD')),
        endDate: z.string().optional().default(dayjs().endOf('year').format('YYYY-MM-DD')),
        range: DateRangeFilterEnum.default('year'),
        assistiveRegime: AssistiveRegimeEnum.optional(),
        sector: z.enum(['outpatient', 'domiciliary']).optional()
    })
)
export type DashboardEconomicSearchParams = z.infer<typeof DashboardEconomicSearchParams>
